<script setup></script>

<template>
  <h2 class="mb-5 text-3xl font-semibold text-secondary-800">
    <slot></slot>
  </h2>
</template>

<style scoped></style>
